var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import translate from "src/i18n/translate";
import { WmButton, WmFlyout } from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import WidgetLoader from "../common/elements/WidgetLoader";
import { NoResults, Table, TableHeader, TableBody } from "../common/helper";
import React, { useReducer } from "react";
import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
var initialState = {
    showAll: false
};
var defaultAction = {
    type: "",
    showAll: false
};
var reducer = function (state, action) {
    switch (action.type) {
        case "toggleShowAll":
            return __assign(__assign({}, state), { showAll: !state.showAll });
        default:
            return state;
    }
};
function sortAlphabetically(instructorList) {
    return instructorList.slice().sort(function (a, b) {
        var firstNameA = a.firstName.toLowerCase();
        var firstNameB = b.firstName.toLowerCase();
        if (firstNameA < firstNameB)
            return -1;
        if (firstNameA > firstNameB)
            return 1;
        return 0;
    });
}
export default function ViewCourseDetails(_a) {
    var CloseDrilldownView = _a.CloseDrilldownView, courseName = _a.courseName, courseCode = _a.courseCode, showTable = _a.showTable, hierarchy = _a.hierarchy, open = _a.open;
    var widgetLabel = useIntl().formatMessage({
        id: "app.programCurriculumEngagement.widgetLabel"
    });
    var trackStudentAssessmentProgress = useIntl().formatMessage({
        id: "app.programCurriculumEngagement.trackStudentAssesmentProgress"
    });
    var courseHeading = "".concat(courseCode, " ").concat(courseName);
    var flyoutWidth = "1316px";
    var getDrilldownColumns = function () {
        return [
            translate("app.drilldown.courseSection"),
            translate("app.drilldown.instructor"),
            translate("app.drilldown.progressStatus"),
            translate("app.drilldown.email")
        ];
    };
    var renderHierarchy = function (node) {
        return (_jsx(React.Fragment, { children: _jsx(Node, { node: node }) }, "".concat(node.uuid, "-hierarchy")));
    };
    var renderHierarchyTable = function () {
        return (_jsxs(Table, { children: [_jsx(TableHeader, { forCourseDetails: true, columns: getDrilldownColumns() }), _jsx(TableBody, { children: hierarchy.map(function (node) {
                        return renderHierarchy(node);
                    }) })] }));
    };
    return (_jsx(WmFlyout, { id: "drill-down-view", eyebrow: widgetLabel, subheading: trackStudentAssessmentProgress, heading: courseHeading, onWmFlyoutCloseTriggered: CloseDrilldownView, open: open, flyoutWidth: flyoutWidth, className: "sll-flyout-container", children: _jsxs("section", { className: "body course-details-body", children: [_jsx("div", { className: "flex-row -justified -verticallycentered", children: _jsxs("div", { children: [_jsxs("div", { className: "title -title", children: [courseCode, " ", courseName] }), _jsx("div", { className: "table-header", children: translate("app.programCurriculumEngagement.progressBySection") }), hierarchy && hierarchy.length > 0 && (_jsx("div", { className: "legend-wrapper", children: _jsxs("div", { className: "legend", "aria-hidden": "true", children: [_jsxs("div", { className: "legend-item", children: [_jsx("div", { className: "legend-color legend1 -legend-wrap" }), _jsx("div", { className: "legend-text", children: translate("app.assessmentProgressChart.awaitingSubmission") })] }), _jsxs("div", { className: "legend-item", children: [_jsx("div", { className: "legend-color legend2 -legend-wrap" }), _jsx("div", { className: "legend-text", children: translate("app.assessmentProgressChart.awaitingAssessment") })] }), _jsxs("div", { className: "legend-item", children: [_jsx("div", { className: "legend-color legend3" }), _jsx("div", { className: "legend-text", children: translate("app.done") })] })] }) }))] }) }), showTable && hierarchy ? (_jsx("div", { className: "org-table", children: !Object.keys(hierarchy).length ? (_jsx(NoResults, {})) : (renderHierarchyTable()) })) : (_jsx("div", { className: "loader", children: _jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" }) }))] }) }));
}
var Node = function (_a) {
    var node = _a.node;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var instructorList = node.instructors;
    var sortedInstructorList = sortAlphabetically(instructorList);
    var instructors = sortedInstructorList.map(function (instructor) {
        return _jsx("div", { children: "".concat(instructor["firstName"], " ").concat(instructor["lastName"]) });
    });
    var leadEmail = node.instructors.map(function (instructor) {
        return "".concat(instructor["email"]);
    });
    var emailInstructorTooltip = useIntl().formatMessage({
        id: "app.programCurriculumEngagement.emailInstructorTooltip"
    }, { sectionNumber: node.sectionNumber, sectionId: node.sectionId });
    var toggleButton = function () {
        dispatch(__assign(__assign({}, defaultAction), { type: "toggleShowAll" }));
    };
    return (_jsxs("tr", { className: "datarow", children: [_jsx("td", { className: "datacell", children: _jsx("div", { className: "course-section", children: "".concat(node["sectionNumber"], " - ").concat(node["sectionId"]) }) }), _jsxs("td", { className: "datacell", children: [_jsx("div", { className: state.showAll ? "instructors show-less" : "instructors show-more", children: instructors }), node.instructors.length > 3 && (_jsx(WmButton, { onClick: toggleButton, "button-type": "textonly", className: "show-more-btn", children: state.showAll
                            ? translate("app.programCurriculumEngagement.showLess")
                            : translate("app.programCurriculumEngagement.showMore") }))] }), _jsx("td", { className: "datacell", children: node.studentAssessments.awaitingSubmission > 0 ||
                    node.studentAssessments.awaitingAssessment > 0 ||
                    node.studentAssessments.done > 0 ? (_jsx(Graph, { node: node })) : (_jsx("div", { children: translate("app.programCurriculumEngagement.NoAssesmentsInProgress") })) }), _jsx("td", { className: "datacell", children: node.instructors.length > 0 && (_jsx("a", { className: "email_link", tabIndex: -1, href: "mailto: ".concat(leadEmail), children: _jsx(WmButton, { "button-type": "icononly", tooltip: emailInstructorTooltip, icon: "f1f0", "icon-size": "18px" }) })) })] }, "".concat(node["uuid"], "-datarow")));
};
var Graph = function (_a) {
    var node = _a.node;
    var awaitingSubmission = useIntl().formatMessage({
        id: "app.assessmentProgressChart.awaitingSubmission"
    });
    var awaitingAssessment = useIntl().formatMessage({
        id: "app.assessmentProgressChart.awaitingAssessment"
    });
    var done = useIntl().formatMessage({
        id: "app.done"
    });
    var awaitingSubmissionTooltip = useIntl().formatMessage({
        id: "app.programCurriculumEngagement.awaitingSubmission"
    });
    var awaitingAssesmentTooltip = useIntl().formatMessage({
        id: "app.programCurriculumEngagement.awaitingAssessment"
    });
    var doneTooltip = useIntl().formatMessage({
        id: "app.programCurriculumEngagement.done"
    });
    var totalStudents = node.studentAssessments.awaitingSubmission +
        node.studentAssessments.awaitingAssessment +
        node.studentAssessments.done;
    return (_jsx("div", { children: _jsx("div", { className: "chart-space", children: _jsxs(WmChart, { "chart-type": "bar4", "value-format": "amount", "show-legend": "false", label: " ", children: [_jsx(WmChartSlice, { legend: awaitingSubmission, amount: String(node.studentAssessments.awaitingSubmission), "popover-text": awaitingSubmissionTooltip, "popover-title": "".concat(node.studentAssessments.awaitingSubmission, "/").concat(totalStudents) }), _jsx(WmChartSlice, { legend: awaitingAssessment, amount: String(node.studentAssessments.awaitingAssessment), "popover-text": awaitingAssesmentTooltip, "popover-title": "".concat(node.studentAssessments.awaitingAssessment, "/").concat(totalStudents) }), _jsx(WmChartSlice, { legend: done, amount: String(node.studentAssessments.done), "popover-text": doneTooltip, "popover-title": "".concat(node.studentAssessments.done, "/").concat(totalStudents) })] }) }) }, String(node.uuid)));
};
